import { Box } from '@mui/material'

function GeneralSettings() {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        height: '100%',
        width: '100%',
        boxSizing: 'border-box',
      }}
    >
      General Settings
    </Box>
  )
}

export default GeneralSettings
